import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-d-flex p-ai-center p-jc-end"
}
const _hoisted_2 = {
  key: 1,
  class: "p-ml-2 p-field"
}
const _hoisted_3 = {
  key: 0,
  class: "p-d-flex p-ai-center p-jc-end"
}
const _hoisted_4 = { class: "p-mr-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-briefcase" }, null, -1)
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("small", { class: "p-ml-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle" }),
  /*#__PURE__*/_createTextVNode(" Il risultato della ricerca verrà applicato ai campi sottostanti. ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-wallet" }, null, -1)
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-euro" }, null, -1)
const _hoisted_14 = { class: "p-formgroup-inline p-mb-3" }
const _hoisted_15 = { class: "p-field-checkbox" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "is_time_cost_active" }, " Attiva costo orario ", -1)
const _hoisted_17 = { class: "p-field-checkbox" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "is_ignore_cost_zone" }, " Ignora costi zona ", -1)
const _hoisted_19 = { class: "p-field-checkbox" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "is_perc_fee_active" }, " Attiva percentuale su fee ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ellipsis-h" }, null, -1)
const _hoisted_22 = {
  key: 1,
  class: "p-field"
}
const _hoisted_23 = { class: "p-float-label" }
const _hoisted_24 = { for: "note" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  hidden: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_AddressAutocomplete = _resolveComponent("AddressAutocomplete")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Skeleton, {
            height: "1rem",
            width: "6rem",
            class: "p-mr-3"
          }),
          _createVNode(_component_Skeleton, {
            height: "2rem",
            width: "3rem"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.showIsActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.modelValue.is_active
                ? _ctx.$t('active')
                : _ctx.$t('inactive')), 1),
                _createVNode(_component_InputSwitch, {
                  modelValue: _ctx.modelValue.is_active,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.modelValue.is_active = $event))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true)
        ])),
    (!_ctx.hideUserData)
      ? (_openBlock(), _createBlock(_component_Fieldset, {
          key: 2,
          class: "p-fluid"
        }, {
          legend: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.user_data')), 1)
          ]),
          default: _withCtx(() => [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_Skeleton, {
                    height: "2rem",
                    class: "p-mb-2"
                  }),
                  _createVNode(_component_Skeleton, {
                    height: "2rem",
                    class: "p-mb-2"
                  })
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_FloatLabel, {
                    class: "p-field",
                    label: _ctx.$t('entity.name') + '*'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputText, {
                        modelValue: _ctx.modelValue.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.name = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_FloatLabel, {
                    class: "p-field",
                    label: _ctx.$t('entity.surname') + '*'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputText, {
                        modelValue: _ctx.modelValue.surname,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue.surname = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
      legend: _withCtx(() => [
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.business_data')), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(8, (a) => {
              return _createVNode(_component_Skeleton, {
                key: `company_${a}`,
                height: "2rem",
                class: "p-mb-2"
              })
            }), 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_FloatLabel, {
                class: "p-field",
                label: _ctx.$t('entity.business_name') + '*'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.modelValue.business_name,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.business_name = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_FloatLabel, {
                class: "p-field",
                label: _ctx.$t('entity.business_city') + '*'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AutoComplete, {
                    modelValue: _ctx.modelValue.business_city,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modelValue.business_city = $event)),
                    suggestions: _ctx.citiesSuggestions,
                    onComplete: _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchCity($event))),
                    onItemSelect: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setCity($event.value))),
                    field: "name"
                  }, null, 8, ["modelValue", "suggestions"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_AddressAutocomplete, {
                  modelValue: _ctx.modelValue.business_address,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.modelValue.business_address = $event)),
                  onSelectedAddress: _ctx.onSelectAddress,
                  label: "Cerca indirizzo *"
                }, null, 8, ["modelValue", "onSelectedAddress"]),
                _hoisted_8
              ]),
              _createVNode(_component_FloatLabel, {
                class: "p-field",
                label: _ctx.$t('entity.business_address') + '*'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.modelValue.business_address,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.modelValue.business_address = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_FloatLabel, {
                class: "p-field",
                label: _ctx.$t('entity.business_state') + '*'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.modelValue.business_state,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.modelValue.business_state = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_FloatLabel, {
                class: "p-field",
                label: _ctx.$t('entity.business_province') + '*'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.modelValue.business_province,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.modelValue.business_province = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_FloatLabel, {
                class: "p-field",
                label: _ctx.$t('entity.business_postal_code') + '*'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.modelValue.business_postal_code,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.modelValue.business_postal_code = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_FloatLabel, {
                class: "p-field",
                label: _ctx.$t('entity.sdi')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.modelValue.sdi,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.modelValue.sdi = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_FloatLabel, {
                class: "p-field",
                label: _ctx.$t('entity.vat') + '*'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.modelValue.vat,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.modelValue.vat = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_FloatLabel, {
                class: "p-field",
                label: _ctx.$t('entity.fiscal_code') + '*'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.modelValue.fiscal_code,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.modelValue.fiscal_code = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ], 64))
      ]),
      _: 1
    }),
    _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
      legend: _withCtx(() => [
        _hoisted_9,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.contact_details')), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (a) => {
              return _createVNode(_component_Skeleton, {
                key: `contacts_${a}`,
                height: "2rem",
                class: "p-mb-2"
              })
            }), 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_FloatLabel, {
                class: "p-field",
                label: _ctx.$t('entity.business_tel') + '*'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.modelValue.business_tel,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.modelValue.business_tel = $event)),
                    maxlength: "15"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_FloatLabel, {
                class: "p-field",
                label: _ctx.$t('entity.pec') + '*'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.modelValue.pec,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.modelValue.pec = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_FloatLabel, {
                class: "p-field",
                label: _ctx.$t('entity.email') + '*'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.modelValue.email,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.modelValue.email = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ], 64))
      ]),
      _: 1
    }),
    (_ctx.showPayment && _ctx.entityIsCustomer)
      ? (_openBlock(), _createBlock(_component_Fieldset, {
          key: 3,
          class: "p-fluid p-mt-3"
        }, {
          legend: _withCtx(() => [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.payment_section')), 1)
          ]),
          default: _withCtx(() => [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (a) => {
                    return _createVNode(_component_Skeleton, {
                      key: `payments_${a}`,
                      height: "2rem",
                      class: "p-mb-2"
                    })
                  }), 64)),
                  _createVNode(_component_Skeleton, {
                    height: "5rem",
                    class: "p-mb-2"
                  })
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_FloatLabel, {
                      class: "p-field",
                      for: "payment_type-dropdown",
                      label: _ctx.$t('entity.payment_type') + '*'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Dropdown, {
                          id: "payment_type-dropdown",
                          options: _ctx.paymentOptions,
                          optionLabel: "label",
                          optionValue: "value",
                          modelValue: _ctx.modelValue.payment_type,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.modelValue.payment_type = $event))
                        }, null, 8, ["options", "modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_FloatLabel, {
                      class: "p-field",
                      label: _ctx.$t('entity.business_note')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Textarea, {
                          id: "business_note",
                          name: "business_note",
                          autoResize: true,
                          rows: "5",
                          cols: "30",
                          modelValue: _ctx.modelValue.business_note,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.modelValue.business_note = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ])
                ], 64))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.entityIsCustomer && _ctx.showCosts)
      ? (_openBlock(), _createBlock(_component_Fieldset, {
          key: 4,
          class: "p-fluid p-mt-3"
        }, {
          legend: _withCtx(() => [
            _hoisted_13,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.costs_section')), 1)
          ]),
          default: _withCtx(() => [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (a) => {
                    return _createVNode(_component_Skeleton, {
                      key: `payments_${a}`,
                      height: "2rem",
                      class: "p-mb-2"
                    })
                  }), 64)),
                  _createVNode(_component_Skeleton, {
                    height: "5rem",
                    class: "p-mb-2"
                  })
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_FloatLabel, {
                      class: "p-field",
                      label: "Costo medio spedizione"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputText, {
                          type: "number",
                          modelValue: _ctx.modelValue.cost_avg_delivery,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.modelValue.cost_avg_delivery = $event)),
                          step: "0.01"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_FloatLabel, {
                      class: "p-ml-3 p-field",
                      label: "Fee (%)"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputText, {
                          type: "number",
                          modelValue: _ctx.modelValue.perc_fee,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.modelValue.perc_fee = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_Checkbox, {
                      binary: true,
                      id: "is_time_cost_active",
                      modelValue: _ctx.modelValue.is_time_cost_active,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.modelValue.is_time_cost_active = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_16
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_Checkbox, {
                      binary: true,
                      id: "is_ignore_cost_zone",
                      modelValue: _ctx.modelValue.is_ignore_cost_zone,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.modelValue.is_ignore_cost_zone = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_18
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Checkbox, {
                      id: "is_perc_fee_active",
                      modelValue: _ctx.modelValue.is_perc_fee_active,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.modelValue.is_perc_fee_active = $event)),
                      binary: true
                    }, null, 8, ["modelValue"]),
                    _hoisted_20
                  ])
                ], 64))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showNote)
      ? (_openBlock(), _createBlock(_component_Fieldset, {
          key: 5,
          class: "p-fluid p-mt-3"
        }, {
          legend: _withCtx(() => [
            _hoisted_21,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.other')), 1)
          ]),
          default: _withCtx(() => [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 0,
                  height: "5rem",
                  class: "p-mb-2"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("span", _hoisted_23, [
                    _createVNode(_component_Textarea, {
                      id: "note",
                      name: "note",
                      autoResize: true,
                      rows: "5",
                      cols: "30",
                      modelValue: _ctx.modelValue.note,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.modelValue.note = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('entity.note')), 1)
                  ])
                ]))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_25
  ], 64))
}